import { Dispatcher } from '../dispatcher/Dispatcher';
import { ActionTypes } from '../constants/ActionTypes';
import { NotificationWebAPIUtils } from '../utils/NotificationWebAPIUtils';
import { NotificationUtils } from '../utils/NotificationUtils';
import { NotificationStore } from '../stores/NotificationStore';
import { NotificationConstants } from '../constants/NotificationConstants';

export const NotificationClientActionCreators = {
  setNotificationChecked: (channelId, subscriptionId, lastCheckedTime) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_CHECKED_TIME,
      channelId,
      subscriptionId,
      lastCheckedTime,
    });
    NotificationWebAPIUtils.updateLastCheckedTime(
      channelId,
      subscriptionId,
      lastCheckedTime
    );
  },

  setAllNotificationsChecked: () => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATIONS_ALL_CHECKED,
    });
    NotificationWebAPIUtils.setAllNotificationsChecked();
  },

  loadMoreNotifications: (
    actionType,
    includeRead,
    itemsPerPage = NotificationConstants.ITEMS_PER_PAGE
  ) => {
    if (
      !NotificationStore.allNotificationsDownloaded(actionType, includeRead) &&
      !NotificationStore.loadingMoreNotifications(actionType, includeRead)
    ) {
      Dispatcher.dispatch({
        type: ActionTypes.NOTIFICATION_LOADING_STATUS,
        actionType,
        includeRead,
        loading: true,
      });
      const nextPage = NotificationStore.nextPageIndex(actionType, includeRead);
      NotificationWebAPIUtils.loadNotifications(
        actionType,
        includeRead,
        nextPage,
        itemsPerPage
      );
    }
  },

  getSettings: () => {
    NotificationWebAPIUtils.getNotificationSettings();
  },

  setSettings: (settings) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_SETTINGS_LOADING,
    });
    const serverSettings = NotificationUtils.serverSettingsFromClient(settings);
    NotificationWebAPIUtils.setNotificationSettings(serverSettings);
  },
};
